import { createSelector } from 'reselect';
import objectToArray from '../../../common/utils/object-to-array';

const preferencesStateSelector = ({ entities: { preferences } = {} }) =>
  preferences;

export const getPreferences = createSelector(
  [preferencesStateSelector],
  preferences => {
    return objectToArray(preferences || {});
  }
);



// WEBPACK FOOTER //
// ./src/redux-modules/customers/selectors/preferences.js